// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";
// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";
import { Link, type LinkProps } from "react-router";

import { focusOutlineStyle } from "metabase/common/style/input";
import { doNotForwardProps } from "metabase/common/utils/doNotForwardProps";

type LinkVariantProp = { variant?: "default" | "brand" | "brandBold" };

export const LinkRoot = styled(
  Link,
  doNotForwardProps("variant"),
)<LinkVariantProp>`
  opacity: ${(props) => (props.disabled ? "0.4" : "")};
  pointer-events: ${(props) => (props.disabled ? "none" : "")};
  transition: opacity 0.3s linear;

  ${focusOutlineStyle("core-brand")};

  ${(props) => variants[props.variant ?? "default"] ?? ""}
` as unknown as React.FC<LinkProps & LinkVariantProp>;

// Underlined by default, not just on :hover — a contextual link identified
// only by color, with no other cue until hovered, isn't visually evident
// to someone who can't perceive the color difference (WCAG 1.4.1).
// text-brand-strong is the contrast-safe brand text token (WCAG 1.4.3);
// core-brand alone fails AA on light surfaces for default Metabase blue.
const variants = {
  default: "",
  brand: css`
    color: var(--mb-color-text-brand-strong);
    text-decoration: underline;
  `,
  brandBold: css`
    color: var(--mb-color-text-brand-strong);
    font-weight: bold;
    text-decoration: underline;
  `,
};
